import React from 'react';
import useDocumentCompletionProgress from 'src/hooks/useDocumentCompletionProgress';
import { InstanceStateData } from 'src/types/state/learningModule';

export interface InlineDocumentProps {
  /** Resolved PDF URL for the instance. */
  pdfUrl: string;
  /** The PDF instance being displayed; its view is recorded as completed. */
  instance: InstanceStateData;
  /** Accessible name for the embedded document. */
  title: string;
  /** Client id the view is attributed to; falls back to the client context. */
  clientId?: string;
}

/**
 * Inline widget rendering of a PDF learning module. Must be rendered inside a
 * `ParentEntityProvider` so the recorded progress carries the parent entity.
 */
const InlineDocument = ({
  pdfUrl, instance, title, clientId,
}: InlineDocumentProps) => {
  useDocumentCompletionProgress(instance, clientId);

  return (
    <div
      className="h-screen w-full bg-su-background-container-content"
      data-testid="inline-pdf-container"
    >
      <object
        className="size-full"
        type="application/pdf"
        data={pdfUrl}
        aria-label={title}
      />
    </div>
  );
};

export default InlineDocument;
